import React from 'react';

import { WppBtnIcon } from './style';

import wppBtnPNG from '../../../assets/images/global-icons/wppBtn.png';

export default function WppButton(): JSX.Element {
  return (
    <WppBtnIcon
      src={wppBtnPNG}
      onClick={() => {
        window.open('https://api.whatsapp.com/send?phone=5511934009574');
      }}
    />
  );
}
